import { render, staticRenderFns } from "./blok-title.vue?vue&type=template&id=a9875640&"
import script from "./blok-title.vue?vue&type=script&lang=js&"
export * from "./blok-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9875640')) {
      api.createRecord('a9875640', component.options)
    } else {
      api.reload('a9875640', component.options)
    }
    module.hot.accept("./blok-title.vue?vue&type=template&id=a9875640&", function () {
      api.rerender('a9875640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/blok-title.vue"
export default component.exports